import { getBrandBySearch } from "services/dataservice";
import { getInventoryBySearch } from "services/dataservice";

export const convertDataToTree = (data) => {
    const getItem = (id) => {
      const item = data.find((item) => item.categoryId === id);
      return {
        value: item.categoryId,
        label: item.name,
        id: item.id,
        children: getChildren(id),
      };
    };
  
    const getChildren = (parentId) => {
      const children = data.filter((item) => item.parentId === parentId);
      return children.map((child) => getItem(child.categoryId));
    };
  
    const mainParent = data.filter((item) => item.parentId === "0");
    const treeData = mainParent.map((item) => getItem(item.categoryId));
    return treeData;
  };

  export const loadInventoryOptions = (e, v) => {
    setTimeout(async () => {
      try {
        const options = await getInventoryBySearch(e);
        const res = options.data.data.map((o) => {
          return {
            value: o.inventoryId,
            label: `${o.inventorySKU}-----${o.productName}`,
            name: `${o.productName}`,
            inventoryId: o.inventoryId,
            costPrice: o.costPrice ?? 0,
            sellingPrice: o.sellingPrice,
            inventorySKU: o.inventorySKU,
            weight: `${o.weight}(kg) ${o.length}(cm) ${o.width}(cm) ${o.height}(cm)`,
          };
        });
        v(res);
      } catch (error) {
        v([]);
      }
    });
  };

  export const loadBrandOptions = (e, v, categoryId, platformName) => {
    if(e.length < 3) return
    if(categoryId===0) return
    setTimeout(async () => {
      try {
        const options = await getBrandBySearch({platformName,categoryId,brand:e});
        const res = options.data.data.map((o) => {
          return {
            value: o.brandId,
            label: `${o.name}`,
            name: `${o.name}`,
          };
        });
        v(res);
      } catch (error) {
        v([]);
      }
    });
  };

  export const renderHTML = (data) => {
    return data.blocks.map(block=>{
      switch (block.type){
        case "header":
          return `<h${block.data.level}>${block.data.text}</h${block.data.level}>`
        case "paragraph":
          return `<p>${block.data.text}</p>`
        default:
          return ''
      }
    }).join("")

  }